
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_18582_1du3d_5",
  "child": "awsui_child_18582_1du3d_9",
  "horizontal": "awsui_horizontal_18582_1du3d_20",
  "horizontal-xxxs": "awsui_horizontal-xxxs_18582_1du3d_24",
  "horizontal-xxs": "awsui_horizontal-xxs_18582_1du3d_28",
  "horizontal-xs": "awsui_horizontal-xs_18582_1du3d_32",
  "horizontal-s": "awsui_horizontal-s_18582_1du3d_36",
  "horizontal-m": "awsui_horizontal-m_18582_1du3d_40",
  "horizontal-l": "awsui_horizontal-l_18582_1du3d_44",
  "horizontal-xl": "awsui_horizontal-xl_18582_1du3d_48",
  "horizontal-xxl": "awsui_horizontal-xxl_18582_1du3d_52",
  "child-horizontal-xxxs": "awsui_child-horizontal-xxxs_18582_1du3d_57",
  "child-horizontal-xxs": "awsui_child-horizontal-xxs_18582_1du3d_63",
  "child-horizontal-xs": "awsui_child-horizontal-xs_18582_1du3d_69",
  "child-horizontal-s": "awsui_child-horizontal-s_18582_1du3d_75",
  "child-horizontal-m": "awsui_child-horizontal-m_18582_1du3d_81",
  "child-horizontal-l": "awsui_child-horizontal-l_18582_1du3d_87",
  "child-horizontal-xl": "awsui_child-horizontal-xl_18582_1du3d_93",
  "child-horizontal-xxl": "awsui_child-horizontal-xxl_18582_1du3d_99",
  "vertical": "awsui_vertical_18582_1du3d_108",
  "child-vertical-xxxs": "awsui_child-vertical-xxxs_18582_1du3d_112",
  "child-vertical-xxs": "awsui_child-vertical-xxs_18582_1du3d_116",
  "child-vertical-xs": "awsui_child-vertical-xs_18582_1du3d_120",
  "child-vertical-s": "awsui_child-vertical-s_18582_1du3d_124",
  "child-vertical-m": "awsui_child-vertical-m_18582_1du3d_128",
  "child-vertical-l": "awsui_child-vertical-l_18582_1du3d_132",
  "child-vertical-xl": "awsui_child-vertical-xl_18582_1du3d_136",
  "child-vertical-xxl": "awsui_child-vertical-xxl_18582_1du3d_140"
};
  